// extracted by mini-css-extract-plugin
var _1 = "ControlBarInsightsButton-module__animateUploadProgressBarWidth--UljX3";
var _2 = "ControlBarInsightsButton-module__animatedBackground--mDUb7";
var _3 = "ControlBarInsightsButton-module__contentContainer--Eyv6G";
var _4 = "ControlBarInsightsButton-module__loading--WJnnE";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "contentContainer", _4 as "loading" }
